import { IAccessibilityMenuLabelsOptions } from '../interfaces/accessibility.interface';

export const ptBRLabels: IAccessibilityMenuLabelsOptions = {
  resetTitle: 'Resetar',
  closeTitle: 'Fechar',
  menuTitle: 'Menu de Acessibilidade',
  increaseText: 'Aumentar texto',
  decreaseText: 'Diminuir texto',
  increaseTextSpacing: 'Aumentar espaçamento',
  decreaseTextSpacing: 'Diminuir espaçamento',
  invertColors: 'Inverter cores',
  grayHues: 'Tons de cinza',
  bigCursor: 'Cursor grande',
  readingGuide: 'Guia de leitura',
  underlineLinks: 'Sublinhar links',
  textToSpeech: 'Texto para fala',
  speechToText: 'Fala para texto',
  disableAnimations: 'Desativar animações',
  increaseLineHeight: 'Aumentar altura de linha',
  decreaseLineHeight: 'Diminuir altura de linha',
  hotkeyPrefix: 'Atalho: ',
  dyslexicFont: 'Fonte para dislexia',
  hideImages: 'Ocultar imagens',
};
